import React from "react";

const Footer: React.FC = () => (
    <footer className="footer">
        <div className="container">
            <div className="footer-top">
                <div className="footer-brand">
                    <span className="footer-logo-text">SYSLOGICS</span>
                    <p>Israel's Premier Enterprise IT Partner</p>
                </div>
                <nav className="footer-nav">
                    <a href="#about">About</a>
                    <a href="#services">Services</a>
                    <a href="#partners">Partners</a>
                    <a href="#contact">Contact</a>
                </nav>
            </div>

            <div className="footer-pillars">
                <div className="footer-pillar">
                    <div className="pillar-rule" />
                    <h4>Innovation</h4>
                    <p>Cutting-edge solutions that keep you ahead of technology trends and competitive challenges.</p>
                </div>
                <div className="footer-pillar">
                    <div className="pillar-rule" />
                    <h4>Reliability</h4>
                    <p>Consistent performance and proactive support ensuring your systems work when you need them most.</p>
                </div>
                <div className="footer-pillar">
                    <div className="pillar-rule" />
                    <h4>Personalization</h4>
                    <p>Tailored solutions and dedicated support that grows and adapts with your unique business needs.</p>
                </div>
            </div>

            <div className="footer-rule" />
            <div className="footer-bottom-content">
                <span>&copy; 2024 Syslogics. All rights reserved.</span>
                <span className="footer-tagline-text">Experience IT That Works For You</span>
                <button className="btn-ghost-sm">Get Started Today</button>
            </div>
        </div>
    </footer>
);

export default Footer;
